import { createSignal } from "solid-js";

import { NUM_QUESTIONS, updateActiveQuestion } from "../stores";
import Header from "../components/Header";

import QuestionJail from "../components/interview/QuestionJail";
//======================= Above this might all be bullshit==========================

import prev from "../assets/prev.svg";
import next from "../assets/next.svg";
import play from "../assets/play.svg";
import submit from "../assets/submit.svg";
import placeholder from "../assets/placeholder.svg";
import subtitles from "../assets/subtitles.svg";
import record from "../assets/record.svg";
import pause from "../assets/pause.svg";

import Mia from "../components/interview/Mia";
import Recording from "../components/interview/Recording";

import { useNavigate } from "@solidjs/router";

import {
  interview,
  setInterview,
  userAnswers,
  setUserAnswers,
  setUserFeedback,
  playState,
  setPlayState,
} from "../stores/userStore";
import {
  synthesizeSpeech,
  stopSpeech,
} from "../services/interviewActions/synthesizeSpeech";
import {
  transcribeSpeech,
  stopTranscribing,
} from "../services/interviewActions/transcribeSpeech";
import {
  sendAnswer,
  generateFeedback,
} from "../services/interviewActions/interviewService";
import { useParams } from "@solidjs/router";
import Loading from "../components/Loading";

export default function Interview() {
  const nav = useNavigate();
  const [questionNum, setNum] = createSignal(0);
  const [recordingState, setRecordingState] = createSignal(false);
  const [subtitleState, setSubtitles] = createSignal(false);
  const [recording, setRecording] = createSignal(false);
  const [loading, setLoading] = createSignal(false);
  const [interviewComplete, setInterviewComplete] = createSignal(false);
  const params = useParams();
  const id = params.id;

  function decrementQuestionNum() {
    if (recordingState() === true) {
      toggleRecording();
    }
    if (questionNum() <= NUM_QUESTIONS - 1 && questionNum() >= 0) {
      setNum(questionNum() - 1);
    }
  }

  async function toggleRecording() {
    if (!recording()) {
      setRecording(true);
      // Start transcribing
      await transcribeSpeech();
    } else {
      // Stop transcribing, send answer to generate feedback and save
      setRecording(false);
      await stopTranscribing(questionNum());
      console.log(`Stored user answers: ${userAnswers()}`);
      await sendAnswer(
        interview().questions[questionNum()],
        userAnswers()[questionNum()],
        id,
        questionNum(),
      );

      if (!userAnswers().includes(null)) {
        setInterviewComplete(true);
      }
    }
  }

  async function toggleSpeech() {
    if (playState()) {
      await synthesizeSpeech(interview().questions[questionNum()]);
    } else {
      stopSpeech();
    }
  }

  function incrementQuestionNum() {
    if (recordingState() === true) {
      toggleRecording();
    }
    if (questionNum() < NUM_QUESTIONS - 1 && questionNum() >= 0) {
      setNum(questionNum() + 1);
    }
  }

  async function submitAnswers() {
    setLoading(true);
    const generalFeedback = await generateFeedback(id);
    setUserFeedback(generalFeedback.feedbackDoc);

    setInterview((inc) => ({
      ...inc,
      status: 0,
    }));
    console.log(interview().status);
    setLoading(false);
    nav("/feedback");
  }

  return (
    <div class="page">
      <Header></Header>

      <div id="mia">
        <Mia />
      </div>

      <div id="subtitles">
        {subtitleState() ? (
          <p>{interview().questions[questionNum()]}</p>
        ) : (
          <p></p>
        )}
      </div>

      <div id="question-interaction">
        {questionNum() > 0 ? (
          <button class="circle-button" onClick={decrementQuestionNum}>
            <img class="arrow-icon-left" src={prev} alt={"Previous"} />
          </button>
        ) : (
          <button class="circle-button-placeholder">
            <img class="icon-placeholder" src={placeholder}></img>
          </button>
        )}

        <div id="question-controls">
          <button
            class="circle-button"
            onClick={() => {
              setPlayState(!playState());
              toggleSpeech();
            }}>
            <img
              class="play-icon"
              src={playState() ? pause : play}
              alt={playState() ? "Pause" : "Play"}
            />
          </button>

          <button
            class="circle-button"
            onClick={() => setSubtitles(!subtitleState())}>
            <img class="subtitle-icon" src={subtitles} alt={"Subtitles"} />
          </button>

          <button
            class="circle-button"
            onClick={() =>
              toggleRecording(recordingState, setRecordingState, questionNum())
            }>
            <Show
              when={recording()}
              fallback={<img class="record-icon" src={record} />}>
              <Recording />
            </Show>
          </button>
        </div>

        {questionNum() < NUM_QUESTIONS - 1 ? (
          <button class="circle-button" onClick={incrementQuestionNum}>
            <img class="arrow-icon-right" src={next} alt={"Next"} />
          </button>
        ) : interviewComplete() ? (
          <button class="circle-button" onClick={submitAnswers}>
            <img class="submit-icon" src={submit} alt={"Submit"}></img>
          </button>
        ) : null}
      </div>

      <div id="interview-footer">
        <QuestionJail
          setNum={setNum}
          focusQuestion={questionNum}></QuestionJail>
      </div>
      <Loading show={loading()} />
    </div>
  );
}
